export const environment = {
  production: false,
  apiUrl: "https://api.studentforms-dev.athabascau.ca",
};
